export enum ProductType {
  unknown = -1,
  singleTicket = 1,
  prepaidTicket = 4,
  periodTicket = 5,
  dayTicket = 6,
  flexTicket = 9,
  partialYearTicket = 10,
  leisureTicket = 12,
}
